import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {UserService} from 'src/app/services/user.service';
import {AuthService} from 'src/app/services/auth.service';
import {BasePage} from '../base.page';
import {LoadingController, Platform, ToastController} from '@ionic/angular';
import {marker} from "@biesbjerg/ngx-translate-extract-marker";

@Component({
  selector: 'app-rating',
  templateUrl: './rating.page.html',
  styleUrls: ['./rating.page.scss'],
})
export class RatingPage extends BasePage implements OnInit {
  ratingForm: FormGroup;
  isLoading = false;
  currentUserId: number;
  ratedUserId: string;
  ratingValue = 0;
  userType: string;
  productId: string;
  hasAlreadyRated = false;
  isCheckComplete: boolean;

  constructor(
    protected platform: Platform,
    protected userService: UserService,
    protected authService: AuthService,
    protected translate: TranslateService,
    protected loadingCtrl: LoadingController,
    toastController: ToastController,
    private route: ActivatedRoute,
    private fb: FormBuilder,
  ) {
    super(platform, userService, authService, translate, loadingCtrl, toastController);
  }

  ngOnInit() {
    this.initializeForm();

    this.userService.getLoggedInUserId().subscribe({
      next: (id) => {
        this.currentUserId = id;

        // Fetch ratedUserId from route
        this.route.paramMap.subscribe(params => {
          this.ratedUserId = params.get('ratedUserId');
          this.userType = params.get('type');
          this.productId = params.get('productId');
          this.checkIfAlreadyRated();
        });
      },
      error: (err) => {
        console.error('Failed to get logged-in user ID:', err);
      }
    });
  }

  initializeForm() {
    this.ratingForm = this.fb.group({
      comment: ['']
    });
  }

  setRating(value: number) {
    this.ratingValue = value;
  }

  async submitRating() {
    if (this.ratingValue === 0) {
      this.showToast(this.translate.instant(marker('Rating.SelectRatingPlease')));
      return;
    }

    this.isLoading = true;

    const payload = {
      rated_by: this.currentUserId,
      user_id: +this.ratedUserId,
      productId: +this.productId,
      rating: this.ratingValue,
      comment: this.ratingForm.value.comment
    };

    try {
      await this.userService.submitRating(payload).toPromise();
      this.showToast(this.translate.instant(marker('Rating.RatingSubmitted')));
      this.hasAlreadyRated = true;
    } catch (error) {
      console.error('Error submitting rating:', error);
    } finally {
      this.isLoading = false;
    }
  }

  checkIfAlreadyRated() {
    this.userService.getUserRatings(+this.ratedUserId).subscribe({
      next: (response) => {
        const ratings = response.ratings || [];
        this.hasAlreadyRated = ratings.some(
          rating =>
            rating.rated_by === this.currentUserId &&
            rating.product_id === +this.productId // 👈 Only block if it's for same product
        );
      },
      error: (err) => {
        console.error('Error checking ratings:', err);
      }
    });
  }
}
